import type { I18nDict } from '../types.ts'

export const de: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Einstellungen',
  section_language: 'Sprache',
  section_identity: 'Lokale Identität',
  section_updates: 'App-Update',
  section_notifications: 'Benachrichtigungen',
  section_theme: 'Visuelles Design',
  section_backup: 'Chat-Backup',
  section_privacy_network: 'Netzwerk-Privatsphäre',
  section_media: 'Multimedia',
  section_security: 'Sicherheit & Passwort',
  section_exit: 'Schließen & Daten löschen',
  toggle_external_links: 'Externe Links empfangen und anzeigen',
  hint_external_links: 'Wenn AUS: keine Link-Vorschauen im Chat und externe URLs können nicht geöffnet werden (IP-Tracking-Schutz).',
  toggle_auto_media: 'Automatischer Download von Medien und Dokumenten',
  hint_auto_media: 'Wenn AUS: Fotos, Videos und Dateien werden nicht im Hintergrund heruntergeladen — manuell im Chat antippen.',
  toggle_require_unlock: 'Passwort beim App-Start',
  hint_require_unlock: 'Wenn AN, ist bei jedem Öffnen von ZION das Master-Passwort erforderlich.',
  toggle_wipe_exit: 'Daten beim Beenden löschen',
  hint_wipe_exit: 'Wenn AN, werden beim Schließen der App temporärer RAM-Cache und Sitzungsdaten gelöscht.',
  btn_exit: 'Beenden',
  btn_delete_all: 'ALLE DATEN LÖSCHEN',
  btn_lock: 'App sperren',
  btn_back: 'Zurück',
  warn_disable_password_title: '⚠️ WARNUNG',
  warn_disable_password_body: 'Das Deaktivieren des Startpassworts bedeutet, dass jeder mit Zugriff auf dein Gerät deine verschlüsselten Nachrichten lesen kann. Bist du sicher, dass du fortfahren möchtest?',
  warn_delete_all_1: 'Möchtest du wirklich die gesamte Datenbank zerstören? Diese Aktion ist unwiderruflich.',
  warn_delete_all_2: 'Letzte Bestätigung: Alle Chats, privaten Schlüssel und Einstellungen werden dauerhaft gelöscht.',
  link_blocked: 'Externer Link blockiert (Privatsphäre-Einstellungen).',
  lang_welcome_title: 'Willkommen bei ZION',
  lang_welcome_sub: 'Wähle deine Sprache',
  lang_continue: 'Weiter',
  settings_language_label: 'App-Sprache',
  auth_unlock_title: 'Entsperren',
  auth_or_password: '— oder mit Passwort entsperren —',
  auth_password_master: 'Master-Passwort',
  auth_unlock_btn: 'Entsperren',
  auth_verifying: 'Wird überprüft…',
  auth_wrong_password: 'Falsches Passwort',
  auth_unlocked: 'Entsperrt ✓',
  auth_access_title: 'ZION beitreten',
  auth_beta_spots: 'Kostenlose Beta · verfügbare Plätze:',
  auth_beta_full: 'Beta voll ({max} Benutzer). Versuche es später erneut.',
  auth_beta_free: 'Kostenlose Beta · keine Lizenz erforderlich',
  auth_or_create: '— oder neue Identität erstellen —',
  auth_password_min: 'Passwort (min. 8 Zeichen)',
  auth_password_confirm: 'Passwort bestätigen',
  auth_privacy_check: 'Ich habe die',
  auth_privacy_link: 'Datenschutzerklärung',
  auth_terms_check: 'Ich akzeptiere die',
  auth_terms_link: 'Nutzungsbedingungen',
  auth_password_local_hint: 'Das Passwort verlässt dieses Gerät nie. Kein Server-Konto.',
  auth_create_identity: 'Identität erstellen',
  auth_accept_legal_err: 'Akzeptiere Datenschutz und Nutzungsbedingungen, um fortzufahren',
  auth_generating_keys: 'Schlüssel und Sitzung werden generiert…',
  auth_generating_identity: 'Anonyme Identität wird generiert…',
  auth_generating_detail: 'ECDH-Schlüssel · Nickname · Socket-Sitzung · ZN- Code',
  auth_you_are: 'Du bist',
  auth_daily_suffix_hint: 'Das tägliche Suffix ändert sich jeden UTC-Tag. Zum Koppeln verwende den ZN- Code auf der Startseite.',
  auth_enter: 'ZION betreten',
  auth_starting: 'Wird gestartet…',
  auth_restore_title: 'Backup wiederherstellen',
  auth_restore_hint: 'Du hast bereits ein verschlüsseltes Backup? Stelle Identität, Kontakte und Chats wieder her (z. B. nach dem Löschen des Caches).',
  auth_restore_file: 'Backup-Datei (.enc / .enc.json)',
  auth_restore_pass: 'Backup-Passphrase',
  auth_restore_pass_ph: 'Beim Export verwendete Passphrase',
  auth_restore_btn: 'Backup wiederherstellen',
  auth_restore_pick_file: 'Wähle eine Backup-Datei (.enc oder .enc.json).',
  auth_restore_need_pass: 'Gib die Passphrase ein.',
  auth_restoring: 'Wird wiederhergestellt…',
  auth_file_prefix: 'Datei:',
  common_accept: 'Annehmen',
  common_reject: 'Ablehnen',
  common_cancel: 'Abbrechen',
  common_accepting: 'Wird angenommen…',
  common_error: 'Fehler',
  common_loading: 'Laden…',
  common_send: 'Senden',
  common_copied: 'Kopiert ✓',
  common_copy_failed: 'Kopieren fehlgeschlagen',
  common_ok: 'OK',
  common_today: 'Heute',
  common_yesterday: 'Gestern',
  common_sending: 'Wird gesendet…',
  home_zn_midnight_hint: 'Wechselt um UTC-Mitternacht (in {h}h {m}m)',
  home_temp_empty: 'Keine Zeitchats. Tippe ⏱ bei einem Kontakt, um einen zu starten.',
  home_unread_aria: '{count} Nachrichten',
  home_temp_waiting: 'Warte auf Annahme…',
  home_temp_expires: 'Zeitchat · läuft ab in {remaining}',
  home_temp_cancel: 'Abbrechen',
  home_temp_fallback_label: 'Zeitchat',
  home_temp_invite_title: '⏱ Einladung zum Zeitchat',
  home_temp_invite_body: '{nick} möchte einen ephemeren Chat ({duration}).',
  home_temp_invite_hint: 'Annehmen, um Nachrichten auszutauschen, die beim Ablauf verschwinden.',
  home_temp_accept: 'Annehmen',
  home_temp_reject: 'Ablehnen',
  home_temp_accepting: 'Wird angenommen…',
  home_contacts_empty: 'Keine Kontakte. Teile deinen ZN- Code oder QR zum Koppeln.',
  home_temp_chat_aria: 'Zeitchat',
  home_btn_pair_title: 'Koppeln',
  home_btn_settings_title: 'Einstellungen',
  home_zn_title: 'Heutiger ZN- Code',
  home_btn_copy_zn: 'ZN- kopieren',
  home_btn_open_pair: 'Kopplungs-QR',
  home_section_temp: 'Zeitchats',
  home_section_chat: 'Chats',
  home_loading: 'Laden…',
  home_pair_zn_title: 'Mit ZN- Code koppeln',
  home_btn_zn_pair: 'Anfrage senden',
  home_copied: 'Kopiert ✓',
  home_copy_failed: 'Kopieren fehlgeschlagen',
  home_pair_request_title: 'Kontaktanfrage',
  home_pair_request_body: '{name} möchte chatten.',
  home_pair_reject: 'Ablehnen',
  home_pair_accept: 'Annehmen',
  home_pair_accepting: 'Wird angenommen…',
  home_pair_accept_failed: 'Annahme fehlgeschlagen',
  home_zn_digits_err: 'Gib die 5 Ziffern nach ZN- ein.',
  home_sending: 'Wird gesendet…',
  chat_rename: 'Umbenennen',
  chat_rename_matrix: '[UMBENENNEN]',
  chat_rename_title: 'Kontakt umbenennen',
  chat_menu_title: 'Chat-Optionen',
  chat_loading: 'Nachrichten werden geladen…',
  chat_reply_to: 'Antwort an',
  chat_cancel_title: 'Abbrechen',
  chat_voice_lock_hint: 'Nach oben wischen, um Aufnahme zu sperren',
  chat_voice_locked: 'Aufnahme gesperrt — Fertig antippen',
  chat_voice_stop: 'FERTIG',
  chat_voice_stop_title: 'Fertig',
  chat_voice_preview_label: 'Sprachvorschau — vor dem Senden anhören',
  chat_voice_send: 'SENDEN',
  chat_voice_send_title: 'Senden',
  chat_timer_label: 'Timer',
  chat_timer_title: 'Nachrichten-Timer',
  chat_timer_off: 'AUS',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Foto',
  chat_photo_title: 'Foto',
  chat_voice_hold: 'Gedrückt halten zum Aufnehmen',
  chat_voice_hold_title: 'Gedrückt halten zum Aufnehmen',
  chat_doc: 'Dok.',
  chat_doc_title: 'Dokument',
  chat_attach_title: 'Anhänge',
  chat_input_placeholder: 'E2E-verschlüsselte Nachricht…',
  chat_send: 'Senden',
  chat_rename_modal_title: 'Kontakt umbenennen',
  chat_rename_nickname: 'Nickname: @{nick}',
  chat_rename_placeholder: 'Eigener Name',
  chat_rename_cancel: 'Abbrechen',
  chat_rename_save: 'Speichern',
  chat_action_reply: '↩ Antworten',
  chat_action_copy: '⎘ Kopieren',
  chat_action_delete_me: '🗑 Für mich löschen',
  chat_action_delete_all: '🗑 Für alle löschen',
  chat_action_cancel: 'Abbrechen',
  chat_menu_clear_me: '🗑 Chat leeren (nur für mich)',
  chat_menu_clear_all: '🗑 Chat für alle löschen',
  chat_menu_cancel: 'Abbrechen',
  chat_doc_send_title: 'Dokument senden',
  chat_doc_default_name: 'Dokument',
  chat_doc_send_hint: 'Die Datei wird komprimiert, E2E-verschlüsselt und gesendet. Max. 5 MB.',
  chat_doc_cancel: 'Abbrechen',
  chat_doc_send_encrypted: 'Verschlüsselt senden',
  chat_doc_too_large: '⚠️ DATEI ZU GROSS: Das maximale Sicherheitslimit für Dokumente beträgt 5 MB.',
  chat_doc_unsupported: 'Nicht unterstützter Dokumenttyp.',
  chat_copy_failed: 'Kopieren fehlgeschlagen',
  chat_confirm_delete_me: 'Diese Nachricht nur für dich löschen?',
  chat_confirm_delete_all: 'Diese Nachricht für alle löschen?',
  chat_confirm_clear_all: 'Den gesamten Chat für alle löschen? Diese Aktion ist unwiderruflich.',
  chat_confirm_clear_me: 'Den Chat nur für dich leeren?',
  chat_jump_new: '↓ Neue Nachrichten',
  chat_empty: 'Keine Nachrichten. Schreib etwas, um zu starten.',
  chat_voice_err_short: 'Sprachnachricht zu kurz (mindestens 1 Sekunde).',
  chat_voice_err_long: 'Sprachnachricht zu lang (maximal 2 Minuten).',
  chat_voice_err_large: 'Sprachnachricht zu gross (max. 3 MB).',
  chat_voice_err_start: 'Sprachaufnahme konnte nicht gestartet werden.',
  chat_destroyed: '✉ Nachricht gelesen und zerstört',
  chat_destroyed_title: 'Nachricht gelesen und zerstört',
  chat_hold_options: 'Gedrückt halten für Optionen',
  chat_reply_fallback: 'Nachricht',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'Der ZN- Code wechselt um UTC-Mitternacht (in {h}h {m}m).',
  pair_copied: 'Kopiert ✓',
  pair_copy_failed: 'Kopieren fehlgeschlagen',
  pair_title: 'Kopplung',
  pair_zn_title: 'Dein ZN- Code heute',
  pair_btn_copy_zn: 'ZN- Code kopieren',
  pair_tab_mine: 'Mein QR',
  pair_tab_scan: 'Scannen / ZN-',
  pair_qr_aria: 'Kopplungs-QR',
  pair_expires_in: 'Läuft ab in',
  pair_btn_copy_payload: 'Payload kopieren',
  pair_btn_regen_qr: 'QR neu generieren',
  pair_qr_hint: 'Zeige diesen QR dem anderen Gerät. 10 Minuten gültig — kompatibel mit der Android-App.',
  pair_expired: 'abgelaufen',
  pair_contact_zn_title: 'ZN- Code des Kontakts',
  pair_zn_prefix_hint: 'Das Präfix <strong>ZN-</strong> ist bereits gesetzt — gib nur die 5 Buchstaben/Ziffern ein.',
  pair_btn_zn_request: 'ZN- Anfrage senden',
  pair_paste_title: 'Oder ZION1:: QR einfügen',
  pair_paste_hint: 'Füge einen <code>ZION1::</code> Payload ein oder lade ein Foto des QR hoch.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Aus Foto / Kamera',
  pair_btn_connect_qr: 'Mit QR verbinden',
  pair_zn_digits_err: 'Gib die 5 Ziffern nach ZN- ein.',
  pair_sending: 'Anfrage wird gesendet…',
  pair_reading_qr: 'QR wird gelesen…',
  pair_qr_not_found: 'QR-Code im Bild nicht gefunden.',
  pair_zn_read_ok: 'ZN- Code gelesen — mit Anfrage senden bestätigen.',
  pair_qr_read_ok: 'QR gelesen — mit Mit QR verbinden bestätigen.',
  pair_qr_read_err: 'Fehler beim Lesen des QR.',
  settings_identity_hint: 'Passwort und Schlüssel bleiben in diesem Browser. Kein Server-Konto.',
  settings_btn_add_home: 'Zum Home-Bildschirm hinzufügen',
  settings_devices_title: 'Verknüpfte Geräte',
  settings_devices_hint: 'Multi-Device Zero-Knowledge: Schlüssel werden E2E-verschlüsselt übertragen. Der Server ist nur ein Relay.',
  settings_btn_link_device: 'Neues Gerät verknüpfen',
  settings_btn_sync_pc: 'PC-Verlauf synchronisieren',
  settings_no_devices: 'Keine verknüpften Geräte.',
  settings_device_self: 'dieses Gerät',
  settings_version_prefix: 'Version:',
  settings_ios_push_hint: '<strong>iPhone:</strong> Benachrichtigungen = PWA vom Home-Bildschirm + Banner/Ton AN. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'App-Update erzwingen',
  settings_updating: 'Wird aktualisiert…',
  settings_push_mode_prefix: 'Modus:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> Benachrichtigungen funktionieren nur, wenn ZION über das Home-Bildschirm-Symbol geöffnet wird (Teilen → Zum Home-Bildschirm). In normalem Safari sind sie <em>nicht</em> verfügbar — auch nicht unter iOS 17. Nach der Installation zum Home-Bildschirm hierher zurückkehren und Benachrichtigungen aktivieren antippen.',
  settings_btn_enable_push: 'Push-Benachrichtigungen aktivieren',
  settings_btn_desktop_notify: 'Desktop-Benachrichtigungen (PC)',
  settings_btn_disable_push: 'Benachrichtigungen deaktivieren',
  settings_desktop_requesting: 'Desktop-Berechtigung wird angefordert…',
  settings_desktop_ok: 'Desktop-Benachrichtigungen aktiv (Ton + Popup bei neuer Nachricht).',
  settings_desktop_denied: 'Berechtigung verweigert oder nicht unterstützt.',
  settings_push_no_session: 'Sitzung nicht bereit.',
  settings_push_requesting: 'Berechtigung wird angefordert…',
  settings_push_active: 'Benachrichtigungen aktiv.',
  settings_push_disabled: 'Benachrichtigungen deaktiviert.',
  settings_theme_hint: 'Gleiche Designs wie in der ZION Android-App.',
  settings_theme_recommended: 'Empfohlen',
  settings_backup_hint: 'JSON-Datei verschlüsselt mit einer Passphrase (kompatibel mit Android v2-Format). Auf dem PC speichern: Kontakte, Chats und Web-Identität.',
  settings_backup_pass_label: 'Backup-Passphrase',
  settings_backup_pass_ph: 'Eigene Passphrase (min. 8 Zeichen)',
  settings_btn_export_backup: 'Backup exportieren',
  settings_backup_file_label: 'Aus Datei wiederherstellen',
  settings_backup_import_pass_label: 'Backup-Passphrase',
  settings_backup_import_pass_ph: 'Beim Export verwendete Passphrase',
  settings_btn_import_backup: 'Backup wiederherstellen',
  settings_backup_file_prefix: 'Datei: {name}',
  settings_backup_pass_min: 'Passphrase muss mindestens 8 Zeichen lang sein.',
  settings_backup_creating: 'Backup wird erstellt…',
  settings_backup_pick_file: 'Wähle eine Backup-Datei (.enc oder .enc.json).',
  settings_backup_need_pass: 'Gib die Backup-Passphrase ein.',
  settings_backup_restoring: 'Wird wiederhergestellt…',
  settings_backup_overwrite_confirm: 'Lokale Daten überschreiben?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 Minuten',
  temp_duration_10m: '10 Minuten',
  temp_duration_15m: '15 Minuten',
  temp_duration_30m: '30 Minuten',
  temp_duration_1h: '1 Stunde',
  temp_duration_6h: '6 Stunden',
  temp_duration_24h: '24 Stunden',
  temp_duration_7d: '7 Tage',
  temp_remaining_expired: 'Abgelaufen',
  temp_remaining_days: '{days}T {hours}h',
  temp_remaining_hours: '{hours}h {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Zeitchat · ephemere Nachrichten',
  temp_empty: 'Keine ephemeren Nachrichten.',
  temp_empty_hint: 'Schreibe eine ephemere Nachricht. Sie verschwindet, wenn der Timer abläuft.',
  temp_input_placeholder: 'Ephemere Nachricht…',
  temp_send: 'Senden',
  temp_waiting_accept: 'Warte darauf, dass {name} den Zeitchat annimmt…',
  temp_waiting_placeholder: 'Warte auf Annahme…',
  temp_expires_in: 'Läuft ab in {remaining}',
  temp_duration_title: 'Zeitchat',
  temp_duration_with: 'Mit {name}',
  temp_duration_hint: 'Wähle die Dauer — der Chat verschwindet von beiden Geräten.',
  temp_sending_invite: 'Einladung wird gesendet…',
  voice_lock_hint: 'Nach oben wischen, um Aufnahme zu sperren',
  voice_locked: 'Aufnahme gesperrt — Fertig antippen',
  add_home_title: 'Zum Home-Bildschirm hinzufügen (iPhone / iPad)',
  add_home_guide_title: 'Safari-Anleitung',
  add_home_step1: 'Öffne <strong>Safari</strong> auf dieser Seite (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Tippe auf <strong>Teilen</strong> (Quadrat mit Pfeil nach oben)',
  add_home_step3: 'Wähle <strong>Zum Home-Bildschirm</strong>',
  add_home_step4: 'Öffne ZION über das <strong>Symbol</strong> — nicht über einen Safari-Tab',
  add_home_hint: 'Unter iOS/iPadOS 16.4+ unterstützt die Home-Bildschirm-App Web-Push-Benachrichtigungen und die Chat-Tastatur. Nach der Installation gehe zu <strong>Einstellungen → Benachrichtigungen aktivieren</strong>.',
  add_home_btn_continue: 'Verstanden — weiter',
  add_home_btn_skip: 'Vorerst überspringen',
  search_title: 'Mit ZN- Code suchen',
  search_label: 'Täglicher ZN- Code',
  search_placeholder: 'ZN-123456',
  search_btn: 'Suchen',
  search_hint: 'Gib den ZN- Code des Kontakts ein. Keine Nickname-Suche — Identität ist nur lokal.',
  search_format_err: 'Format: ZN-123456',
  search_resolving: 'Code wird aufgelöst…',
  search_invalid_code: 'Ungültiger Code — bitte um einen aktualisierten ZN- (ZION auf dem Gerät der anderen Person neu öffnen)',
  search_session_found: 'Sitzung gefunden',
  search_tap_to_send: 'Antippen, um Anfrage zu senden',
  search_socket_not_ready: 'Socket-Sitzung nicht bereit',
  search_request_sent: 'Anfrage gesendet ✓',
  search_request_failed: 'Senden fehlgeschlagen',
  license_title: 'Web- / iPhone-Lizenzaktivierung',
  license_heading: 'Lizenz',
  license_heading_updated: 'Aktualisierte Bedingungen',
  license_hint: 'Gib den auf zionyx.ch gekauften Code <strong>ZION-XXXX-XXXX-XXXX</strong> ein. Er wird mit diesem Browser verknüpft (lokaler Schlüssel).',
  license_code_label: 'Lizenzcode',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Lizenz aktivieren',
  license_beta_hint: 'Web-Beta: verwende eine dedizierte iPhone-Lizenz, falls verfügbar.',
  license_accept_legal_err: 'Akzeptiere Datenschutz und Nutzungsbedingungen, um fortzufahren',
  license_need_code: 'Gib den Lizenzcode ein',
  license_verifying: 'Lizenz wird überprüft…',
  license_invalid_or_used: 'Ungültige Lizenz oder bereits auf einem anderen Gerät verwendet',
  license_active: 'Lizenz aktiv ✓',
  license_err_not_found: 'Ungültiger Lizenzcode',
  license_err_conflict: 'Lizenz bereits mit einem anderen Gerät verknüpft',
  license_err_rate_limit: 'Zu viele Versuche — warte eine Minute',
  license_err_generic: 'Lizenzfehler',
  link_device_title: 'Neues Gerät verknüpfen',
  link_device_hint: 'Öffne auf deinem <strong>PC</strong> Einstellungen → Neues Gerät verknüpfen: Du siehst den <strong>grünen QR</strong>. Scanne ihn unten (Kamera oder Foto).',
  link_device_status_ready: '[BEREIT]',
  link_device_upload_label: 'QR-Foto hochladen',
  link_device_btn_camera: 'Kamera / Galerie öffnen',
  link_device_placeholder: 'QR-Link oder Payload…',
  link_device_btn_send_vault: 'Verschlüsselten Tresor senden',
  link_device_err_invalid_qr: 'Ungültiger oder abgelaufener QR.',
  link_device_status_invalid: '[UNGÜLTIGER QR]',
  link_device_status_sync_complete: '[SYNC ABGESCHLOSSEN]',
  link_device_status_transfer_failed: '[ÜBERTRAGUNG FEHLGESCHLAGEN]',
  link_device_status_qr_detected: '[QR ERKANNT — WIRD ÜBERTRAGEN...]',
  link_device_status_tap_camera: '[GRÜNEN BUTTON ANTIPPEN — IPHONE-KAMERA]',
  link_device_status_use_camera_below: '[KAMERA / GALERIE UNTEN VERWENDEN]',
  link_device_status_point_camera: '[KAMERA AUF PC-QR RICHTEN...]',
  link_device_status_decoding: '[QR WIRD DEKODIERT...]',
  link_device_status_qr_not_found: '[QR NICHT GEFUNDEN]',
  link_device_status_decode_failed: '[DEKODIERUNG FEHLGESCHLAGEN]',
  link_device_status_opened_from_qr: '[VOM QR GEÖFFNET — WIRD GESTARTET...]',
  link_recv_title: 'Vom Telefon verknüpfen',
  link_recv_hint_compact:
    'Scanne diesen <strong>grünen QR</strong> mit dem Telefon (Einstellungen → Neues Gerät verknüpfen). Der Vault ist Ende-zu-Ende verschlüsselt.',
  link_recv_hint_auth:
    'Hast du ZION schon auf dem Telefon? Scanne diesen QR mit der <strong>Kamera</strong> — der PC verknüpft sich und meldet sich automatisch an.',
  link_recv_qr_alt: 'QR zur Geräteverknüpfung',
  link_recv_copy_link: 'Link kopieren',
  link_recv_awaiting: '[WARTE AUF TELEFON-SCAN — TUNNEL OFFEN...]',
  link_recv_failed: '[KOPPLUNG FEHLGESCHLAGEN]',
  link_recv_tunnel_lost:
    'Tunnel unterbrochen — der Vault könnte noch unterwegs sein. Scanne den QR erneut.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Neue verschlüsselte Nachricht',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Ephemere Nachricht',
  force_update_title: '🚨 PFLICHT-KRITISCHES UPDATE — Um Zionyx weiterhin sicher zu nutzen, musst du die neueste Version herunterladen.',
  force_update_desc: 'Der installierte Client ist nicht mit der auf dem Server aktiven Mindestversion kompatibel.',
  force_update_versions: 'Installiert: v{current} · Erforderlich: v{required}',
  force_update_btn: 'JETZT AKTUALISIEREN',
}
